import React from "react";
import { ArrowPathIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { formatVal } from "./DetailRow";

export default function OrderHeaderActions({
    selectedOrder,
    cancelingOrder,
    actionSubmitting,
    triggerCancelConfirm,
    onStatusChange,
    orderStatuses = [],
    statusesLoading = false,
    statusesError = false
}) {
    const s = (selectedOrder?.order_status || selectedOrder?.status || "").toLowerCase();

    function normalizeStatusString(status) {
        if (!status) return "";
        return status.toLowerCase().replace(/^wc-/, "").replace(/[-_]/g, "");
    }

    const sNormalized = normalizeStatusString(s);
    const isCancelled = ["cancelled", "canceled", "trash", "failed"].includes(sNormalized);

    let badgeClass = "bg-blue-50 text-blue-700 border border-blue-200";
    if (isCancelled) {
        badgeClass = "bg-red-50 text-red-700 border border-red-200";
    } else if (sNormalized === "pending" || sNormalized === "on-hold" || sNormalized === "on_hold") {
        badgeClass = "bg-amber-50 text-amber-700 border border-amber-200";
    } else if (sNormalized === "completed") {
        badgeClass = "bg-green-50 text-green-700 border border-green-200";
    }


    return (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 border-b border-gray-100 pb-5">
            {/* Left Section: Cancel Order Actions */}
            <div className="flex-1 flex items-center justify-start">
                {!isCancelled && (
                    <div className="flex items-center gap-4 flex-wrap">
                        <button
                            disabled={cancelingOrder || actionSubmitting}
                            onClick={triggerCancelConfirm}
                            className="px-4 py-2 border border-red-500 text-red-500 font-bold rounded hover:bg-red-50 transition text-xs bg-white disabled:opacity-50 flex items-center justify-center min-w-[100px]"
                        >
                            {cancelingOrder && (
                                <ArrowPathIcon className="h-3 w-3 animate-spin mr-1.5 text-red-500" />
                            )}
                            {cancelingOrder ? "Canceling..." : "Cancel Order"}
                        </button>
                        <div className="flex items-center gap-2 border border-red-200 bg-red-50/50 text-red-700 px-4 py-2 rounded-lg text-xs">
                            <ExclamationTriangleIcon className="h-4 w-4 text-red-500" />
                            <span>This will cancel the order and initiate a refund.</span>
                        </div>
                    </div>
                )}
            </div>

            {/* Right Section: Order Metadata */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-xs text-left">
                <span className="text-gray-900 font-bold">Order ID</span>
                <span className="font-bold text-gray-900 text-right">{formatVal(selectedOrder?.order_id)}</span>
                <span className="text-gray-900 font-bold">Order Number</span>
                <span className="font-bold text-gray-900 text-right">{formatVal(selectedOrder?.order_number)}</span>
                <span className="text-gray-900 font-bold">Order Status</span>
                <span className="font-bold text-gray-900 text-right">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${badgeClass}`}>
                        {formatVal(sNormalized)}
                    </span>
                </span>
                <span className="text-gray-900 font-bold">Date</span>
                <span className="font-bold text-gray-900 text-right">{formatVal(selectedOrder?.order_date)}</span>
            </div>
        </div>
    );
}
